import { History } from 'history';
import { combineReducers } from 'redux';
import { reducer as data } from '../data/store';
import entities from '../entities/reducers';
import views from '../view/reducers';

export interface IState {
	data: ReturnType<typeof data>;
	entities: ReturnType<typeof entities>;
	views: ReturnType<typeof views>;
}

export default (history: History) => combineReducers<IState>({
	data,
	entities,
	views
});
